export type EmployeeStatus = "INTERN" | "PROBATION" | "OFFICIAL" | "RESIGNED";

export const employeeStatusTrans: Record<EmployeeStatus, { label: string; color: string; bgcolor: string }> = {
  INTERN: { label: "Thực tập", color: "#b54708", bgcolor: "#fffaeb" },
  PROBATION: { label: "Thử việc", color: "#175cd3", bgcolor: "#eff8ff" },
  OFFICIAL: { label: "Nhân viên chính thức", color: "#027a48", bgcolor: "#d1fadf" },
  RESIGNED: { label: "Nghỉ việc", color: "#667085", bgcolor: "#f2f4f7" },
};

export const employeeStatusOptions = (Object.keys(employeeStatusTrans) as EmployeeStatus[]).map((value) => ({
  value,
  label: employeeStatusTrans[value].label,
}));

// Nhân sự nhận hoa hồng kỹ thuật: "" = không nhận; mỗi vai trò chỉ gán cho 1 người
export type TechnicalCommissionRole = "" | "CHUONG" | "DUNG";

export const technicalCommissionRoleOptions: { label: string; value: TechnicalCommissionRole }[] = [
  { label: "Không", value: "" },
  { label: "HH Chương", value: "CHUONG" },
  { label: "HH Dung", value: "DUNG" },
];

export interface Department {
  id: number;
  name: string;
  description?: string;
  sortOrder?: number;
  employeeCount?: number;
}

export interface Employee {
  id: number;
  code: string;
  name: string;
  phone: string;
  email: string;
  status: EmployeeStatus;
  technicalCommissionRole?: TechnicalCommissionRole;
  lastReviewDate: string;
  nextReviewDate: string;
  probationStartDate: string;
  officialDate: string;
  resignedDate: string;
  department?: Department | null;
  staff?: { id: number; name: string; username: string } | null;
  // Chỉ có khi người xem có quyền "Xem thông tin nhạy cảm"
  idNumber?: string;
  baseSalary?: number;
  lastReviewSalary?: number;
  bankAccount?: string;
  bankName?: string;
}
